import moment from "moment-timezone";
import { useTranslation } from "react-i18next";
import { cn } from "../../../../lib/utils";

interface UnavailableEventProps {
    event: any;
    style?: any;
    variant?: "rose" | "neutral";
}

function UnavailableEvent({ event, style, variant = "neutral" }: UnavailableEventProps) {
    const { t } = useTranslation();
    const isRose = variant === "rose";

    const timeDisplay = !event.allDay
        ? moment(event.startDate).format("hh:mma") + " - " + moment(event.endDate).format("hh:mma")
        : t("all-day");

    return (
        <div
            className={cn(
                "unavailable-block tw-flex tw-flex-col unavailable-details tw-justify-center tw-items-center align-center tw-absolute tw-w-full tw-px-2",
                isRose
                    ? "tw-bg-rose-100 tw-text-rose-500"
                    : "tw-bg-neutral-100 tw-truncate tw-border tw-border-dashed tw-border-neutral-200"
            )}
            style={style}
        >
            <p className={cn(isRose && "tw-text-rose-500", "tw-opacity-100")}>
                {t("unavailable")}
            </p>
            <p
                className={cn(
                    "tw-font-bold tw-opacity-100",
                    isRose ? "tw-text-rose-500" : "tw-text-xs tw-truncate"
                )}
            >
                {timeDisplay}
            </p>
        </div>
    );
}

export default UnavailableEvent;
